import { ADDRESS_VERIFICATION_SINGLE_INPUT } from '~/src/features/full-buy/constants/abnTest';
import { getABNVariant } from '~/src/helpers/abn-tests';

const isOneLineAddressScreen = (): boolean => {
    return getABNVariant(ADDRESS_VERIFICATION_SINGLE_INPUT.testName) === ADDRESS_VERIFICATION_SINGLE_INPUT.variants.on;
};

export default isOneLineAddressScreen;
